<template>
  <div class="flex-1 flex flex-col p-2 bg-white rounded-sm mt-2">
    <div class="flex items-center justify-between mb-3 pl-1">
      <h3 class="text-lg font-bold text-gray-800 flex items-center">
      
        Forced Registrations
      </h3>
    </div>
    <div class="grid grid-cols-8 gap-2 py-2" v-if="stats">
      <div class="stat-card text-gray-500">
        <label class="text-2xl font-bold">{{ stats.pending }}</label>
        <label class="text-sm">Pending</label>
      </div>
      <div class="stat-card">
        <label class="text-2xl font-bold">{{ stats.submitted }}</label>
        <label class="text-sm">Submitted</label>
      </div>
      <div class="stat-card text-blue">
        <label class="text-2xl font-bold">{{ stats.assigned }}</label>
        <label class="text-sm">Assigned</label>
      </div>
      <div class="stat-card text-purple-600">
        <label class="text-2xl font-bold">{{ stats.cleared || 0 }}</label>
        <label class="text-sm">Cleared</label>
      </div>
      <div class="stat-card text-amber-600">
        <label class="text-2xl font-bold">{{ stats.returned || 0 }}</label>
        <label class="text-sm">Returned</label>
      </div>
      <div class="stat-card text-success-600">
        <label class="text-2xl font-bold">{{ stats.approved }}</label>
        <label class="text-sm">Approved</label>
      </div>
      <div class="stat-card text-danger-600">
        <label class="text-2xl font-bold">{{ stats.rejected }}</label>
        <label class="text-sm">Rejected</label>
      </div>
      <div class="stat-card">
        <label class="text-2xl font-bold">{{ stats.total }}</label>
        <label class="text-sm">Total</label>
      </div>
    </div>

    <!-- Filters -->
    <div class="bg-white rounded shadow p-3 mb-2 flex flex-wrap items-end gap-3">
      <!-- Tracking Number -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Tracking Number</label>
        <input
          v-model="trackingNumber"
          type="text"
          placeholder="Enter Tracking No."
          class="border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
          @keyup.enter="fetch"
        />
      </div>

      <!-- Name -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Name</label>
        <input
          v-model="name"
          type="text"
          placeholder="Enter Name"
          class="border border-gray-300 rounded px-2 py-1 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
          @keyup.enter="fetch"
        />
      </div>

      <!-- Status -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Status</label>
        <select
          v-model="statuses"
          class="border border-gray-300 rounded px-2 py-1 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          @change="fetch"
        >
          <option :value="null">-- Filter by Status --</option>
          <option value="DRAFT">Draft</option>
          <option value="PENDING">In Queue</option>
          <option value="ASSIGNED">Assigned</option>
          <option value="SUBMITTED">Submitted</option>
          <option value="CLEARED">Cleared</option>
          <option value="RETURNED">Returned</option>
          <option value="LINKED">Linked</option>
          <option value="APPROVED">Approved</option>
          <option value="QUERIED">Queried</option>
        </select>
      </div>

      <!-- Type -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Type</label>
        <select
          v-model="typeId"
          class="border border-gray-300 rounded px-2 py-1 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          @change="onTypeChange"
        >
          <option :value="null">-- Filter by Type --</option>
          <option
            v-for="type in primaryEntityTypes"
            :key="type.id"
            :value="type.id"
          >
            {{ type.name }}
          </option>
        </select>
      </div>

      <!-- Sub Type -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Sub Type</label>
        <select
          v-model="subTypeId"
          class="border border-gray-300 rounded px-2 py-1 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          @change="fetch"
        >
          <option :value="null">-- Filter by Sub Type --</option>
          <option
            v-for="type in subEntityTypes"
            :key="type.id"
            :value="type.id"
          >
            {{ type.name }}
          </option>
        </select>
      </div>

      <!-- Institution -->
      <div class="flex flex-col">
        <label class="text-xs font-semibold text-gray-600 mb-1">Associate Register </label>
        <select
          v-model="institutionId"
          class="border border-gray-300 rounded px-2 py-1 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
          @change="fetch"
        >
          <option :value="null">-- Filter by Associate Register --</option>
          <option
            v-for="inst in institutions"
            :key="inst.id"
            :value="inst.id"
          >
            {{ inst.name }}
          </option>
        </select>
      </div>

      
    </div>

    <div class="bg-white rounded shadow flex flex-col">
      <div class="overflow-x-auto flex-1">
        <table class="min-w-full leading-normal">
          <thead>
          <tr class="border-b border-t border-grey">
            <th class="t-header">#</th>
  
            <th class="t-header">Interim ERN</th>
            <th class="t-header">Name</th>
            <th class="t-header">Type</th>
            <th class="t-header">Sub Type</th>
            <th class="t-header text-center">Status</th>
            <th class="t-header text-center">Date</th>
            <th class="t-header text-center">Action</th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="(application, idx) in applications"
              :key="application.id || idx"
              :class="[(idx % 2) ? rows.even : rows.odd]"
          >
            <td class="t-body">{{ ((page - 1) * limit) + idx + 1 }}</td>
       
            <td class="t-body">
              {{ application.interimErn || '--' }}
            </td>
            <td class="t-body font-semibold">
              {{ application.name ? application.name.toUpperCase() : '' }}
            </td>
            <td class="t-body">
              {{ application.type }}
            </td>
            <td class="t-body">
              {{ application.subType || '--' }}
            </td>
            <td class="t-body text-center">
                <span
                    class="text-[10px] font-semibold px-2.5 py-1 rounded-full inline-block"
                    :class="statusClass(application.status)"
                    :style="statusStyle(application.status)"
                >
                  {{ application.status ? application.status.toUpperCase().replaceAll("_", " ") : '' }}
                </span>
            </td>
            <td class="t-body text-center text-gray-400">
              {{ dateTimeFormat(application.createdAt) }}
            </td>
            <td class="t-body text-center">
              <button
                v-if="application.status === 'PENDING' || application.status === 'ASSIGNED'"
                @click="openAssign(application)"
                class="bg-blue text-white px-2 py-1 rounded text-xs hover:bg-blue-dark mr-2"
              >
                Assign
              </button>
              <button
                @click="open(application)"
                class="bg-blue text-white px-2 py-1 rounded text-xs hover:bg-blue-dark mt-1"
              >
                View
              </button>
            </td>
          </tr>
          <tr v-if="applications && applications.length === 0">
            <td colspan="11" class="bg-inertgrey text-center py-4">
              <span class="text-sm">No applications submitted</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div
      class="mt-2 flex flex-wrap items-center justify-between"
      v-if="pagination && pagination.totalPages > 1"
    >
      <div class="flex items-center gap-2">
        <button @click="previous" :class="(page > 1) ? 'paginate-btn' : 'inert-btn'">
          Previous
        </button>
        <div class="paginate-details text-center">
          <span class="bg-blue text-white px-2 py-1 rounded-sm text-xs">
            {{ page }}/{{ pagination.totalPages }}
          </span>
        </div>
        <button @click="next" :class="(page < pagination.totalPages) ? 'paginate-btn' : 'inert-btn'">
          Next
        </button>
      </div>

      <div class="flex items-center gap-3">
        <select
          v-model.number="limit"
          class="w-full text-xs form-select border-0 paginate-details"
          @change="fetch"
        >
          <option :value="15">15</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <p class="paginate-details text-center text-xs font-bold">
          <span>{{ ((page - 1) * limit) + 1 }}</span> -
          <span v-if="limit > applications.length ">{{ pagination.totalRows }}</span>
          <span v-else>{{ page * limit }}</span>
          of {{ pagination.totalRows }}
        </p>
      </div>
    </div>
    <AppModal v-model="viewModalOpen" xl6>
      <div v-if="canViewActionWithPermission('can_process_forced_registrations', 'forced_registrations')" class="flex items-center justify-between gap-3 pb-2 mt-2" id="action-buttons">
          <div>
            <div
              v-if="selectedTask && selectedTask.message"
              class="relative bg-emerald-50 text-emerald-900 text-sm font-medium px-4 py-2 rounded-xl border border-emerald-300 shadow-md flex items-center gap-2 max-w-xl"
              style="background-color: #ecfdf5; border-color: #a7f3d0; color: #065f46;"
            >
              <i class="fas fa-comment-alt text-base text-emerald-600 mr-1" style="color: #059669;"></i>
              <span>{{ selectedTask.message }}</span>
            </div>
          </div>
          <button
              v-if="selectedTask && (selectedTask.status === 'SUBMITTED' || selectedTask.status === 'RETURNED')"
              class="btn-approve ml-auto"
              :disabled="!selectedTaskId"
              @click="openTransitionForm"
          >
            <i class="fas fa-check-circle text-white mr-1"></i> Approve & Transition
          </button>
        </div>
      <TaskView :task="selectedTask" />
    </AppModal>

    <b-modal id="modal-transition-forced" v-model="showTransitionModal" title="Approve & Transition Forced Registration" hide-footer size="lg">
      <div class="p-3">
        <b-row class="mb-4">
          <b-col cols="12">
            <div class="h6 text-gray-800 font-bold mb-1">Classification Details</div>
            <p class="text-xs text-gray-500">Specify the institution and entity classification to approve and transition this forced registration.</p>
          </b-col>
        </b-row>
        
        <b-form @submit.prevent="submitTransition">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-form-group label="Associate Register (Institution) *" label-class="text-xs font-semibold text-gray-600 mb-1">
                <select
                  v-model="selectedInstitutionId"
                  required
                  class="w-full border border-gray-300 rounded px-2 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
                  @change="onModalInstitutionChange"
                >
                  <option :value="null">-- Select Associate Register --</option>
                  <option
                    v-for="inst in institutions"
                    :key="inst.id"
                    :value="inst.id"
                  >
                    {{ inst.name }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
            
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Primary Entity Type *" label-class="text-xs font-semibold text-gray-600 mb-1">
                <select
                  v-model="selectedEntityTypeId"
                  required
                  :disabled="!selectedInstitutionId"
                  class="w-full border border-gray-300 rounded px-2 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                  @change="onModalTypeChange"
                >
                  <option :value="null">-- Select Primary Type --</option>
                  <option
                    v-for="type in modalPrimaryEntityTypes"
                    :key="type.id"
                    :value="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
            
            <b-col cols="12" md="6" class="mb-3">
              <b-form-group label="Sub Entity Type" label-class="text-xs font-semibold text-gray-600 mb-1">
                <select
                  v-model="selectedSubEntityTypeId"
                  class="w-full border border-gray-300 rounded px-2 py-1.5 text-xs bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  <option :value="null">-- Select Sub Type --</option>
                  <option
                    v-for="type in modalSubEntityTypes"
                    :key="type.id"
                    :value="type.id"
                  >
                    {{ type.name }}
                  </option>
                </select>
              </b-form-group>
            </b-col>
          </b-row>
          
          <b-row class="mt-4">
            <b-col cols="6">
              <button
                type="button"
                class="px-3 py-2 border border-gray-300 bg-white rounded text-gray-700 w-full text-xs font-semibold hover:bg-gray-50"
                @click="showTransitionModal = false"
              >
                Cancel
              </button>
            </b-col>
            <b-col cols="6">
              <button
                type="submit"
                class="px-3 py-2 bg-green rounded text-white w-full text-xs font-semibold hover:bg-green-dark flex justify-center items-center"
                :disabled="transitioning"
              >
                <i v-if="transitioning" class="fas fa-spinner fa-spin mr-2"></i>
                <i v-else class="fa fa-check-circle mr-2"></i>
                Approve & Transition
              </button>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </b-modal>

    <b-modal id="modal-a-assign" hide-footer ref="assignSubmissions" title="Assign to Registrar">
      <Assignment :id="selectedApplication ? (selectedApplication.taskId || selectedApplication.id) : null" type="nir" permission="can_view_non_individual_tasks"/>
    </b-modal>

    <b-modal id="modal-are-you-sure" v-model="areYouSure" title="Confirm" hide-footer size="md" >
      <div class="p-1">
        <div class="flex items-start mb-4">
          
          <div class="ml-4 flex-1">
            
            <b-row>
          <b-col>
            <p class="text-sm">
              <span class="h6">Are you sure you are ready to take this action ?</span>.<br/>
              This action can only be reversed by your superiors. Only confirm if you are certain that this is the appropriate Final Decision
            </p>
            <p class="mt-3 text-sm italic">
              <b>Note:</b><br/>
              All actions performed on <b class="text-blue">OBRS</b> are recorded and details of the account that initiated are tagged to the action.
            </p>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col cols="4">
            <button class="px-3 py-2 border-2 border-blue bg-white rounded-sm text-blue w-full" @click="areYouSure = false">
              <i class="fa fa-minus-square text-blue mr-2"></i>Cancel</button>
          </b-col>
          <b-col cols="4"></b-col>
          <b-col cols="4">
            <button class="px-3 py-2 bg-green rounded-sm text-white w-full hover:bg-green-dark" @click="confirmedToExecuteNextAction">
              <i class="fa fa-check-circle text-white mr-1"></i> Accept</button>
          </b-col>
        </b-row>
              
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {api} from "../../../../../app/services/api.service";
import { dateTimeFormat } from '../nir/utils/dateTimeFormat';
import AppModal from '../nir/components/AppModal.vue';
import TaskView from '../nir/views/TaskView.vue';
import Assignment from "../../../commons/Assignment.vue";

export default {
  name: 'ForcedRegistrations',
  components: { AppModal, TaskView, Assignment },
  data() {
    return {
      loading: false,
      viewModalOpen: false,
      selectedTaskId: '',
      selectedTask: null,
      selectedApplication: null,
      page: 1,
      limit: 15,
      applications: [],
      stats: null,
      // filters
      trackingNumber: '',
      name: '',
      statuses: null,
      typeId: null,
      subTypeId: null,
      institutionId: null,
      startRegistrationDate: null,
      endRegistrationDate: null,
      primaryEntityTypes: [],
      subEntityTypes: [],
      institutions: [],
      rows: {
        odd: 'border-t border-grey hover:bg-header_grey',
        even: 'border-t border-grey hover:bg-header_grey',
      },
      pagination: {
        currentPage: 1,
        nextPage: 0,
        totalPages: 0,
        totalRows: 0,
      },
      areYouSure: false,
      pendingAction: null,
      transitioning: false,
      showTransitionModal: false,
      selectedInstitutionId: null,
      selectedEntityTypeId: null,
      selectedSubEntityTypeId: null,
      modalPrimaryEntityTypes: [],
      modalSubEntityTypes: [],
    };
  },
  mounted() {
    this.fetch();
    this.fetchStatistics();
    this.fetchInstitutions();
    this.fetchPrimaryEntityTypes();
    try {
      localStorage.removeItem('applicationId');
    } catch (e) {
      console.error('Error removing applicationId from localStorage:', e);
    }
  },
  methods: {
    dateTimeFormat,
    fetch() {
      var self = this;
      this.loading = true;
      let path = '/nir/api/v1/applications/forced?page=' + this.page + '&limit=' + this.limit;

      if (this.statuses) {
        path += '&status=' + encodeURIComponent(this.statuses);
      }
      if (this.trackingNumber && this.trackingNumber.trim() !== '') {
        path += '&trackingNumber=' + encodeURIComponent(this.trackingNumber.trim());
      }
      if (this.name && this.name.trim() !== '') {
        path += '&name=' + encodeURIComponent(this.name.trim());
      }
      if (this.typeId) {
        path += '&typeId=' + encodeURIComponent(this.typeId);
      }
      if (this.subTypeId) {
        path += '&subTypeId=' + encodeURIComponent(this.subTypeId);
      }
      if (this.institutionId) {
        path += '&institutionId=' + encodeURIComponent(this.institutionId);
      }
      if (this.startRegistrationDate) {
        path += '&startRegistrationDate=' + encodeURIComponent(this.startRegistrationDate);
      }
      if (this.endRegistrationDate) {
        path += '&endRegistrationDate=' + encodeURIComponent(this.endRegistrationDate);
      }

      api().get(path)
          .then(function (res) {
            if (res.data && res.data.data) {
              var data = res.data.data;
              self.applications = data.content || [];
              if (data.pagination) {
                self.pagination = data.pagination;
                if (typeof data.pagination.currentPage === 'number') {
                  self.page = data.pagination.currentPage;
                }
              } else {
                self.pagination = { currentPage: 1, nextPage: 0, totalPages: 0, totalRows: 0 };
              }
            } else {
              self.applications = [];
              self.pagination = { currentPage: 1, nextPage: 0, totalPages: 0, totalRows: 0 };
            }
            self.loading = false;
          })
          .catch(function () {
            self.loading = false;
          });
    },
    canViewActionWithPermission(permission) {
      return this.$can(permission, "general") === true;
    },
    fetchStatistics() {
      const self = this;
      api().get('/nir/api/v1/applications/forced/stats')
          .then(function (res) {
            if (res.data && res.data.data) {
              self.stats = res.data.data;
            }
          });
    },
    fetchInstitutions() {
      var self = this;
      api().get('/nir/api/v1/institutions?page=1&limit=1000')
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.content) {
              self.institutions = res.data.data.content;
            } else {
              self.institutions = [];
            }
          })
          .catch(function () {
            self.institutions = [];
          });
    },
    fetchPrimaryEntityTypes() {
      var self = this;
      api().get('/nir/api/v1/configurations/entity-types/primary')
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.primaryEntityTypes = res.data.data.data;
            } else {
              self.primaryEntityTypes = [];
            }
          })
          .catch(function () {
            self.primaryEntityTypes = [];
          });
    },
    fetchSubEntityTypes(parentId) {
      var self = this;
      if (!parentId) {
        this.subEntityTypes = [];
        return;
      }
      api().get('/nir/api/v1/configurations/entity-types?parentId=' + encodeURIComponent(parentId))
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.subEntityTypes = res.data.data.data;
            } else {
              self.subEntityTypes = [];
            }
          })
          .catch(function () {
            self.subEntityTypes = [];
          });
    },
    onTypeChange() {
      this.subTypeId = null;
      this.fetchSubEntityTypes(this.typeId);
      this.fetch();
    },
    next() {
      if (this.pagination && this.page < this.pagination.totalPages) {
        this.page += 1;
        this.fetch();
      }
    },
    previous() {
      if (this.page > 1) {
        this.page -= 1;
        this.fetch();
      }
    },
    open(application) {
      this.viewModalOpen = true;
      this.selectedTaskId = application.id;
      this.selectedTask = {
        ...application,
        applicationType: "FORCED_REGISTRATION"
      };
    },
    openAssign(application) {
      this.selectedApplication = application;
      this.$refs.assignSubmissions.show();
    },
    resume(id) {
      try {
        localStorage.setItem('applicationId', id);
      } catch (e) {
        console.error('Failed to set applicationId in localStorage:', e);
      }
      if (this.$router) {
        this.$router.push({ name: 'nir-registration-new' });
      }
    },
    statusStyle(status) {
      const s = status ? status.toUpperCase() : '';
      switch (s) {
        case 'CLEARED':
          return { backgroundColor: '#e0e7ff', color: '#3730a3', border: '1px solid #c7d2fe' };
        case 'RETURNED':
        case 'QUERIED':
          return { backgroundColor: '#fef3c7', color: '#92400e', border: '1px solid #fde68a' };
        case 'APPROVED':
        case 'AUTO_ADMITTED':
        case 'LINKED':
          return { backgroundColor: '#dcfce7', color: '#166534', border: '1px solid #bbf7d0' };
        case 'REJECTED':
          return { backgroundColor: '#fee2e2', color: '#991b1b', border: '1px solid #fca5a5' };
        case 'ASSIGNED':
        case 'SUBMITTED':
          return { backgroundColor: '#dbeafe', color: '#1e40af', border: '1px solid #bfdbfe' };
        case 'PREAPPROVAL':
          return { backgroundColor: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' };
        default:
          return { backgroundColor: '#f3f4f6', color: '#4b5563', border: '1px solid #e5e7eb' };
      }
    },
    statusClass(status) {
      var map = {
        DRAFT: 'bg-gray-100 text-gray-500',
        QUERIED: 'bg-yellow-100 text-yellow-800',
        RETURNED: 'bg-yellow-100 text-yellow-800',
        PENDING: 'bg-gray-100 text-gray-700',
        PREAPPROVAL: 'bg-green-50 text-green-700 border border-green-200',
        SUBMITTED: 'bg-blue-50 text-blue-700',
        ASSIGNED: 'bg-blue-100 text-blue-800',
        CLEARED: 'bg-indigo-100 text-indigo-800',
        APPROVED: 'bg-green-100 text-green-800',
        AUTO_ADMITTED: 'bg-green-100 text-green-800',
        LINKED: 'bg-green-100 text-green-800',
        REJECTED: 'bg-red-100 text-red-800',
      };
      return map[status ? status.toUpperCase() : ''] || 'bg-gray-100 text-gray-600';
    },
    showAreYouSure(action) {
      this.pendingAction = action;
      this.areYouSure = true;
    },
    confirmedToExecuteNextAction() {
      this.areYouSure = false;
      if (this.pendingAction === 'approve') {
        this.confirmTransition();
      }
      this.pendingAction = null;
    },
    confirmTransition() {
      this.transitioning = true;
      api().post('/nir/api/v1/applications/transition-forced-registration', { applicationId: this.selectedTaskId })
          .then(() => {
            this.transitioning = false;
            this.viewModalOpen = false;
            this.fetch();
            this.fetchStatistics();
            this.successToast('Success', 'Application approved successfully');
          })
          .catch((error) => {
            this.transitioning = false;
            this.errorToast(' Error', JSON.stringify(error));
          });
    },
    openTransitionForm() {
      this.selectedInstitutionId = this.selectedTask ? this.selectedTask.institutionId : null;
      this.selectedEntityTypeId = this.selectedTask ? this.selectedTask.entityTypeId : null;
      this.selectedSubEntityTypeId = this.selectedTask ? this.selectedTask.subEntityTypeId : null;
      this.fetchModalPrimaryEntityTypes(this.selectedInstitutionId);
      if (this.selectedEntityTypeId) {
        this.fetchModalSubEntityTypes(this.selectedEntityTypeId);
      } else {
        this.modalSubEntityTypes = [];
      }
      this.showTransitionModal = true;
    },
    fetchModalPrimaryEntityTypes(institutionId) {
      var self = this;
      if (!institutionId) {
        this.modalPrimaryEntityTypes = [];
        return;
      }
      let url = '/nir/api/v1/configurations/institution/types/primary?id=' + encodeURIComponent(institutionId);
      api().get(url)
          .then(function (res) {
            if (res.data && res.data.data) {
              self.modalPrimaryEntityTypes = Array.isArray(res.data.data) ? res.data.data : (res.data.data.data || []);
            } else {
              self.modalPrimaryEntityTypes = [];
            }
          })
          .catch(function () {
            self.modalPrimaryEntityTypes = [];
          });
    },
    fetchModalSubEntityTypes(parentId) {
      var self = this;
      if (!parentId) {
        this.modalSubEntityTypes = [];
        return;
      }
      api().get('/nir/api/v1/configurations/entity-types?parentId=' + encodeURIComponent(parentId))
          .then(function (res) {
            if (res.data && res.data.data && res.data.data.data) {
              self.modalSubEntityTypes = res.data.data.data;
            } else {
              self.modalSubEntityTypes = [];
            }
          })
          .catch(function () {
            self.modalSubEntityTypes = [];
          });
    },
    onModalInstitutionChange() {
      this.selectedEntityTypeId = null;
      this.selectedSubEntityTypeId = null;
      this.modalSubEntityTypes = [];
      this.fetchModalPrimaryEntityTypes(this.selectedInstitutionId);
    },
    onModalTypeChange() {
      this.selectedSubEntityTypeId = null;
      this.fetchModalSubEntityTypes(this.selectedEntityTypeId);
    },
    submitTransition() {
      this.transitioning = true;
      const payload = {
        applicationId: this.selectedTaskId,
        institutionId: this.selectedInstitutionId,
        entityTypeId: this.selectedEntityTypeId,
        subEntityTypeId: this.selectedSubEntityTypeId
      };
      var self = this;
      api().post('/nir/api/v1/applications/transition-forced-registration', payload)
          .then(() => {
            self.transitioning = false;
            self.showTransitionModal = false;
            self.viewModalOpen = false;
            self.fetch();
            self.fetchStatistics();
            self.successToast('Success', 'Application transitioned successfully');
          })
          .catch((error) => {
            self.transitioning = false;
            self.errorToast('Error', error.response && error.response.data && error.response.data.message ? error.response.data.message : JSON.stringify(error));
          });
    },
  },
};
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.btn-escalate{
  @apply border border-blue bg-white rounded-sm text-blue text-sm px-3 py-1 mx-1;
}

.btn-escalate:hover{
  @apply text-blue-dark;
}

.btn-approve{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-query{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-reject{
  @apply border bg-blue rounded-sm text-white text-sm px-3 py-1 mx-1 bg-white;
}

.btn-approve:hover{
  @apply bg-green border-green text-white;
}

.btn-query:hover{
  @apply bg-orange border-orange text-white;
}

.btn-reject:hover{
  @apply bg-red border-red text-white;
}

.flex-1 { flex: 1; }
.flex { display: flex; }
.flex-col { flex-direction: column; }
.p-2 { padding: 0.5rem; }
.grid { display: grid; }
.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.gap-2 { gap: 0.5rem; }
.py-2 { padding-top: 0.5rem; padding-bottom: 0.5rem; }
.stat-card {
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
  padding: 0.75rem;
}

.text-success-600 { color: #059669; }
.text-danger-600 { color: #dc2626; }
.flex-gap-2 { display: flex; gap: 0.5rem; }

.paginate-details {
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn {
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover {
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn {
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>
